import { type Auth0ClientOptions } from '@auth0/auth0-spa-js';
import { getEnvVariable } from 'utils/helpers/getEnvVariable';
import { getIsAlamaly } from 'utils/helpers/getIsAlamaly';
import { getIsYokohama } from 'utils/helpers/getIsYokohama';

interface IAuth0ClientOptions extends Auth0ClientOptions {
  domain: string;
  clientId: string;
  audience: string;
  redirectURI: string;
}

const isYokohamaDomain = getIsYokohama();
const isAlamalyDomain = getIsAlamaly();

const authClientOptions: IAuth0ClientOptions = {
  domain: getEnvVariable('REACT_APP_AUTH0_DOMAIN'),
  clientId: isYokohamaDomain
    ? getEnvVariable('REACT_APP_YOKOHAMA_AUTH0_CLIENT_ID')
    : isAlamalyDomain
    ? getEnvVariable('REACT_APP_ALAMALY_AUTH0_CLIENT_ID')
    : getEnvVariable('REACT_APP_AUTH0_CLIENT_ID'),

  audience: getEnvVariable('REACT_APP_AUTH0_AUDIENCE'),
  redirectURI: isYokohamaDomain
    ? getEnvVariable('REACT_APP_YOKOHAMA_REDIRECT_URI')
    : isAlamalyDomain
    ? getEnvVariable('REACT_APP_ALAMALY_REDIRECT_URI')
    : getEnvVariable('REACT_APP_REDIRECT_URI'),
};

export default authClientOptions;
